<template>
  <div
    class="wrapper layout_dashboard"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      short-title="Mandaa"
      title="Mandaa"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: this.$t('dashboard:sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: this.$t('dashboard:sidebar.invoices'),
            icon: 'tim-icons icon-notes',
            path: '/invoices/view',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: this.$t('dashboard:sidebar.customers'),
            icon: 'tim-icons icon-single-02',
            path: '/receivers/view',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: this.$t('dashboard:sidebar.contact'),
            icon: 'tim-icons icon-email-85',
            path: '/contact',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <div class="content">
        <FadeTransition :duration="200" mode="out-in">
          <router-view></router-view>
        </FadeTransition>
      </div>
      <dashboard-footer></dashboard-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import { FadeTransition } from "vue2-transitions";

import "perfect-scrollbar/css/perfect-scrollbar.css";
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}
function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
import DashboardNavbar from "./DashboardNavbar.vue";
import DashboardFooter from "./DashboardFooter.vue";
import DashboardCss from "@/assets/sass/index_dashboard.scss";
import SidebarFixedToggleButton from "./black_dashboard_pro/Layout/SidebarFixedToggleButton.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardNavbar,
    DashboardFooter,
    FadeTransition,
    SidebarFixedToggleButton,
  },
  created() {
    if (!this.authenticatedUser) {
      window.location.href = "/login";
    }
  },
  data() {
    return {
      sidebarBackground: "default", //vue|blue|orange|green|red|primary
    };
  },

  computed: {
    ...mapGetters("auth", {
      authenticatedUser: "user",
    }),
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      const docClasses = document.body.classList;
      const isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style lang="css">
body {
  margin: 0;
  font-family: "Poppins";
}
</style>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
